import { useState } from 'react';
import { Button } from 'react-bootstrap';
import { FiUpload } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import '../../../assets/css/Drivers/DriverSetting/DriverDocumentRegistration.css';
import DriverSettingsMasterLayout from '../../../layouts/Drivers/DriverSettingsMasterLayout';


const DriverDocumentRegistration = () => {
  const navigate = useNavigate();
  const [documents, setDocuments] = useState({
    DriverImage: null,
    drivingLicense: null,
    nationalId: null,
    vehicleDetail: null,
  });

  const handleFileChange = (documentType, event) => {
    const file = event.target.files[0];
    if (file) {
      setDocuments({
        ...documents,
        [documentType]: file
      });
    }
  };

  const handleUpdate = () => {
        navigate('/driver-setting');
      };
  const DocumentUploadBox = ({ title, documentType }) => (
    <div className="driver-document-upload-box">
      <p className="driver-document-title">{title}</p>
      <label htmlFor={documentType} className="driver-document-upload-label">
        <FiUpload className="driver-document-upload-icon" />
        <span className="driver-document-upload-text">Upload</span>
        <input
          type="file"
          id={documentType}
          className="driver-document-file-input"
          onChange={(e) => handleFileChange(documentType, e)}
          accept="image/*,.pdf"
        />
      </label>
      {documents[documentType] && (
        <p className="driver-document-file-name">{documents[documentType].name}</p>
      )}
    </div>
  );

  return (
    <DriverSettingsMasterLayout screenName={"Document Registration"} centered={true}>
      <div className="driver-document-container">
      <div className="driver-document-wrapper">

        <div className="driver-document-content">
        <DocumentUploadBox 
            title="Driver Image" 
            documentType="DriverImage" 
          />
          <DocumentUploadBox 
            title="Driving License" 
            documentType="drivingLicense" 
          />
          
          <DocumentUploadBox 
            title="National ID any ID Proof" 
            documentType="nationalId" 
          />
          <DocumentUploadBox 
            title="Vehicle Detail" 
            documentType="vehicleDetail" 
          />
          <Button 
            className="driver-document-update-btn"
            onClick={handleUpdate}
          >
            Update
          </Button>
        </div>
      </div>
    </div>
    </DriverSettingsMasterLayout>
    
  );
};

export default DriverDocumentRegistration;